
const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gold-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              Pronto para realizar seus objetivos financeiros?
            </h2>
            <p className="text-xl text-white/80 mb-8 leading-relaxed">
              Fale agora com nossos especialistas e descubra a melhor solução de crédito para você. Atendimento rápido, seguro e sem compromisso.
            </p>

            <a
              href="https://wa.me/5519971344445?text=Olá! Quero falar com um especialista sobre crédito."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Falar com um especialista agora
            </a>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-gold-400 mb-2">+5.000</div>
              <div className="text-white/80 text-sm">Clientes Satisfeitos</div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-gold-400 mb-2">Até 48h</div>
              <div className="text-white/80 text-sm">Para liberação de crédito</div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-gold-400 mb-2">1,85%</div>
              <div className="text-white/80 text-sm">Consignados INSS</div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-gold-400 mb-2">100%</div>
              <div className="text-white/80 text-sm">Seguro e confiável</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
